import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

const FinalCTA = () => {
  return (
    <section className="py-10 sm:py-20 bg-gradient-to-br from-ink-blue-900 via-ink-blue-800 to-ink-blue-900 text-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-60 h-60 sm:w-80 sm:h-80 bg-soft-lavender-500/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-60 h-60 sm:w-80 sm:h-80 bg-sunset-coral-400/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 sm:w-96 sm:h-96 bg-gradient-to-r from-soft-lavender-500/10 to-sunset-coral-400/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full glass-dark text-white/80 text-xs sm:text-sm font-semibold mb-5 sm:mb-8 backdrop-blur-sm border border-white/20">
            <Sparkles className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            Ready to ship?
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-8 leading-[1.15]">
            Ready to experience{" "}
            <span className="text-gradient-sunset">
              the Joylo difference?
            </span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-white/80 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed">
            Join thousands of teams who've transformed their workflow with Joylo's AI-powered platform.
            Start building amazing applications today.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-6 mb-10 sm:mb-16">
            <a
              href="https://joylo.io"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-sunset hover:opacity-90 text-white font-bold px-8 sm:px-12 py-3.5 sm:py-5 text-base sm:text-lg rounded-xl shadow-elegant-xl hover:shadow-elegant-xl transition-all duration-300 transform hover:scale-105 inline-flex items-center justify-center"
            >
              Start Free
              <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
            </a>
            <a
              href="https://joylo.io"
              target="_blank"
              rel="noopener noreferrer"
              className="glass-dark text-white hover:bg-white/20 border border-white/30 hover:border-white/50 font-bold px-8 sm:px-12 py-3.5 sm:py-5 text-base sm:text-lg rounded-xl backdrop-blur-sm transition-all duration-300 text-center"
            >
              Schedule Demo
            </a>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-x-5 sm:gap-x-8 gap-y-2 text-white/60">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-soft-lavender-400 rounded-full animate-pulse flex-shrink-0"></div>
              <span className="text-xs sm:text-sm">No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-sunset-coral-400 rounded-full animate-pulse flex-shrink-0"></div>
              <span className="text-xs sm:text-sm">Start in 30 seconds</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-soft-lavender-400 rounded-full animate-pulse flex-shrink-0"></div>
              <span className="text-xs sm:text-sm">Enterprise-grade security</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;